// src/services/admissionService.ts
import { postData } from "../Axios/Axios";

export const submitAdmission = async (data: any) => {
  return await postData("/v1/admissions/enroll", data);
};
